import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player/lazy';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Button from 'components/Button';
import Panel from 'components/Panel';
import FormattedText from 'components/FormattedText';
import Card from 'components/Card';
import Landmark from 'components/Landmark';
import { AdminOrHubButtonLink } from 'components/AdminOrHubLink';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import track from 'utils/track';
import { PLATFORM_ANNOUNCEMENTS_ROUTE } from 'utils/routes';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getAnnouncementSubtitle(publishTime) {
  if (!publishTime) {
    return i18n.t('content_processing_status_draft');
  }
  var publishDate = new Date(publishTime);
  var today = new Date();
  var isToday = publishDate.getDate() === today.getDate() && publishDate.getMonth() === today.getMonth() && publishDate.getFullYear() === today.getFullYear();
  if (isToday) {
    return i18n.t('time_today');
  }
  return getLocalisedDate({
    date: publishTime,
    options: {
      month: 'short',
      year: 'numeric',
      day: 'numeric'
    },
    isInLocalTimezone: false
  });
}
function PlatformAnnouncementModal(_ref) {
  var announcement = _ref.announcement,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var hasPlayedRef = useRef(false);
  var titleId = "platform-announcement-modal-title-".concat(announcement.id);
  var showViewAllButton = location.pathname !== PLATFORM_ANNOUNCEMENTS_ROUTE;
  function handlePlayVideo() {
    if (!hasPlayedRef.current) {
      track('announcement', 'watchedVideo', announcement.id);
      hasPlayedRef.current = true;
    }
  }
  return /*#__PURE__*/_jsx(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    width: "extraWide",
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        titleId: titleId,
        title: announcement.title,
        subtitle: getAnnouncementSubtitle(announcement.publishTime),
        onClose: onClose
      }), /*#__PURE__*/_jsx(Panel, {
        children: (announcement === null || announcement === void 0 ? void 0 : announcement.HTMLmessage) && /*#__PURE__*/_jsx(FormattedText, {
          dangerouslySetInnerHTML: {
            __html: announcement.HTMLmessage
          }
        })
      }), announcement.videoUrl && /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx("div", {
          style: {
            width: '100%',
            height: '100%',
            position: 'relative',
            paddingTop: '56.25%' /* Player ratio: 100 / (1280 / 720) */
          },
          children: /*#__PURE__*/_jsx(ReactPlayer, {
            fallback: /*#__PURE__*/_jsx(Landmark, {
              icon: "spinner",
              height: 250,
              children: t('loading_video')
            }),
            style: {
              position: 'absolute',
              top: 0,
              left: 0
            },
            playing: false,
            url: announcement.videoUrl,
            controls: true,
            width: "100%",
            height: "100%",
            onPlay: handlePlayVideo,
            config: {
              youtube: {
                playerVars: {
                  start: 0
                }
              }
            }
          })
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: announcement.buttonLabel && announcement.buttonLink ? /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          as: "a",
          onClick: function onClick() {
            return track('announcement', 'open', announcement.id);
          },
          href: announcement.buttonLink,
          target: "_blank",
          rel: "noopener noreferrer",
          children: announcement.buttonLabel
        }) : /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: onClose,
          children: t('actions_close')
        })
      }), showViewAllButton && /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(AdminOrHubButtonLink, {
          variant: "transparent",
          size: "small",
          origin: "hub",
          to: PLATFORM_ANNOUNCEMENTS_ROUTE,
          children: t('actions_view_all_announcements')
        })
      })]
    })
  });
}
export default PlatformAnnouncementModal;